import React from "react";
import { Link } from "react-router-dom";
import EssenceActionsDropdown from "../EssenceActionsDropdown";
import EssenceStateLabel from "../EssenceStateLabel";
export default function StaffListRow(props) {
  let values = [];
  for (let field in props) values.push(field);

  let literal = props["fullname"] ? props["fullname"][0].toUpperCase() : null;
  let literalBg = "bg-light";
  if (props.lock_date) literalBg = "bg-light-danger";

  const info = props.info || {};

  const onClick = (e) => {
    if (props.onItemClick) {
      props.onItemClick(e, props.listItemId);
    }
  };

  let selectedItems = Array.isArray(props.selectedItems)
    ? props.selectedItems
    : [];

  let itemClasses = "row py-4  border-bottom text-dark list-item";
  itemClasses += props.highlightItem === String(props.id) ? " current" : "";
  itemClasses += selectedItems.includes(props.id) ? " active" : "";

  return (
    <div className={itemClasses} onClick={onClick}>
      <div style={{ wordBreak: "break-all" }} className="col-lg-6 m-lg-0 my-3">
        <Link
          onClick={(e) => {
            e.stopPropagation();
            onClick(e);
          }}
          to={`/staff/${props.id}/`}
          className="text-dark"
        >
          <div className="d-flex justify-content-start align-items-center">
            <div className="symbol symbol-20 symbol-lg-40 mr-3 align-middle">
              {info.picture ? (
                <img alt="userpic" src={info.picture} />
              ) : (
                <span className={`symbol-label ${literalBg}`}>{literal}</span>
              )}
            </div>
            {props.fullname}
          </div>
        </Link>
      </div>

      <div
        title="Должность"
        className="col-lg-2 text-dark-50 small  d-flex align-items-center"
      >
        {props.positionname}
      </div>
      <div className="col-lg-2  text-dark-50 small">
        {props.structurename && (
          <div className="text-dark-75">{props.structurename}</div>
        )}
        {props.areaname && <div>{props.areaname}</div>}
      </div>
      <div className="col-lg-2  d-flex align-items-center justify-content-end text-right">
        <EssenceStateLabel
          id={props.id}
          stateCode={props.statetypecode}
          stateLabel={props.statelabel}
          essence="staff"
        />

        <EssenceActionsDropdown
          essence={"staff"}
          key={props.id}
          id={props.id}
          label={props.label}
          attendantItems={props.selectedItems}
          onPending={props.onPending}
        />
      </div>
    </div>
  );
}
